import { Box, Typography } from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import _ from "lodash";
import StringUtils from "../../Utils/StringUtils";
import { useState } from "react";
import VanDetailsDialog from "./VanDetailsDialog";

const VanDetails = ({
  checkIfVANAvailable,
  lendingProvider,
  agroStarVanDetails,
  externalLendersVanDetails,
}) => {
  const [open, setOpen] = useState(false);
  const [selectedLenderVanDetails, setSelectedLenderVanDetails] =
    useState(null);

  let vanDetailsData = [];
  if (lendingProvider === "AGROSTAR" || !lendingProvider) {
    vanDetailsData.push(agroStarVanDetails);
  } else {
    vanDetailsData.push(agroStarVanDetails);
    if (externalLendersVanDetails?.length > 0) {
      vanDetailsData.push(...externalLendersVanDetails);
    }
  }

  return (
    <Box
      sx={{
        background: "#FFFFFF",
        borderRadius: 2.4,
        padding: "8px 16px",
        margin: "12px 0px",
      }}
    >
      <Typography variant={`body2`} sx={{ fontWeight: "700", mb: 0.5 }}>
        VAN Details
      </Typography>

      {checkIfVANAvailable() ? (
        <>
          <Typography sx={{ fontSize: "12px" }}>
            Please select the VAN account for payment
          </Typography>

          {_.map(vanDetailsData, (vanDetails, index) => {
            return (
              <Box
                key={index}
                sx={{
                  borderRadius: "16px",
                  boxShadow: "2px 4px 15px rgba(0, 0, 0, 0.1)",
                  padding: "8px 16px",
                  mt: 1.5,
                  mb: 1,
                  display: "flex",
                  justifyContent: "space-between",
                  backgroundColor: "#FFFFFF",
                }}
                onClick={() => {
                  setOpen(true);
                  setSelectedLenderVanDetails(vanDetailsData?.[index]);
                }}
              >
                <img
                  src={vanDetails?.iconPath}
                  height={25}
                  alt={StringUtils.convertToTitleCase(
                    vanDetails?.lendingProvider
                  )}
                />
                <Typography
                  fontWeight={700}
                  sx={{
                    fontSize: "12px",
                    display: "flex",
                    alignItems: "center",
                    color: vanDetails?.color,
                  }}
                >
                  {StringUtils.convertToTitleCase(vanDetails?.lendingProvider)}{" "}
                  VAN Account
                  <ArrowForwardRoundedIcon sx={{ marginLeft: 0.5 }} />
                </Typography>
              </Box>
            );
          })}
        </>
      ) : (
        <Typography
          variant={"body2"}
          sx={{
            marginBottom: 1,
            marginTop: 1,
            color: "#000000",
            opacity: "0.6",
          }}
        >
          Coming Soon...
        </Typography>
      )}

      <VanDetailsDialog
        open={open}
        handleClose={() => {
          setOpen(false);
          setSelectedLenderVanDetails(null);
        }}
        vanDetails={selectedLenderVanDetails}
      />
    </Box>
  );
};

export default VanDetails;
